import React, { useState, useEffect, useRef } from "react";
import "./ListItem.css";
import sampleUser from "../../assets/user.jpg";
function ListItem({ memberName, memberPosition }) {
  return (
    <div className='latest-member-user-container'>
      <div className='latest-member-user-image'>
        <img src={sampleUser} alt='' />
      </div>
      <div className='latest-member-user-details'>
        <p>{memberName}</p>
        <small>{memberPosition}</small>
      </div>
    </div>
  );
}
export default ListItem;
